import type { NetworkPayload } from "../../../composites";

export namespace API {
  export namespace FetchHolidays {
    export type Response = {
      holidays: { name: string; start_time: string; end_time: string }[];
    };
    export type Error = unknown;
  }

  export const fetchHolidays = () =>
    ({
      url: "support/schedules/holidays",
      options: {
        method: "GET",
      },
    }) satisfies NetworkPayload;
}
